/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    onChangesetUpdate: (changeset: EmberChangeset) => void;
  };
}

export default class TreatmentHistoryProtocolUtilsProtocolSectionComponent extends Component<Signature> {
  get allCureIndexes(): number[] {
    return Array.from({ length: 6 }, (_, index) => index + 2);
  }
}
